import type { ChatRoom } from '../types';

/** Доступный чат: привязан к отклику (chat:br:{id}), не legacy chat:tutor:student. */
export const isAccessibleChatRoomId = (roomId: string | null | undefined): boolean => {
  if (!roomId) {
    return false;
  }
  const parts = roomId.split(':');
  if (parts.length !== 3 || parts[0] !== 'chat' || parts[1] !== 'br') {
    return false;
  }
  return /^\d+$/.test(parts[2]);
};

export const isAccessibleChatRoom = (room: {
  room_id?: string | null;
  other_user_id?: number;
}): boolean => {
  if (!isAccessibleChatRoomId(room.room_id)) {
    return false;
  }
  return (room.other_user_id ?? 0) > 0;
};

/** Найти комнату из списка доступных по chatId или roomId из URL. */
export const findAccessibleChatRoom = (
  rooms: ChatRoom[],
  params: { chatId?: string | null; roomId?: string | null },
): ChatRoom | null => {
  if (params.roomId) {
    const byRoom = rooms.find((room) => room.room_id === params.roomId);
    if (byRoom) {
      return byRoom;
    }
  }
  if (params.chatId) {
    const byId = rooms.find((room) => room.id === params.chatId);
    if (byId) {
      return byId;
    }
  }
  return null;
};
